module.exports = __webpack_public_path__ + "static/img/img_3.385396b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_resource_management/img_3.jpg
// module id = si74
// module chunks = 0